module.exports = __webpack_public_path__ + "static/EnmTX_BosDragon_L_A_cl-a130f65f2e1958b342a7ae673a77f26d.gif";